/** Default max packets before cashback proceed is blocked (API may override via packetTarget). */
export const DEFAULT_SCAN_PACKET_LIMIT = 10;

export const getScanPacketLimit = (data) => {
    const target = Number(data?.packetTarget ?? data?.targetScanCount);
    return Number.isFinite(target) && target > 0 ? target : DEFAULT_SCAN_PACKET_LIMIT;
};

/** True when user has scanned more than the allowed packet limit (e.g. > 10). */
export const isScanLimitReached = (data) => {
    const count = Number(data?.scanCount ?? 0);
    const limit = getScanPacketLimit(data);
    return count > limit;
};

/** Backend limit message for display on genuinity-check modal. */
export const getScanLimitNotice = (data) => {
    const raw =
        data?.nextLevelMsg ??
        data?.secondaryRewardMsg ??
        data?.secondaryMessage ??
        data?.SecondaryMessage ??
        data?.primaryRewardMsg ??
        data?.primaryMessage ??
        data?.PrimaryMessage ??
        "";
    return String(raw).trim();
};
